import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import {
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../../../../_lib/epocus-palette";

export const SwitchToGuidedProcedureDialog: FC<{
  open: boolean;
  switching: boolean;
  onClose: () => void;
  onConfirm: () => void;
}> = ({ open, switching, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>
      <Typography
        style={{
          fontSize: rem(18),
          fontWeight: 700,
          color: EPOCUS_TEXT_PRIMARY,
        }}
      >
        Switch to guided joint injection?
      </Typography>
    </DialogTitle>
    <DialogContent>
      <Typography style={{ fontSize: rem(13), color: EPOCUS_TEXT_SECONDARY }}>
        This exam becomes a guided joint / bursa injection worksheet and its MSK
        findings are cleared. Side and site carry over where they can, and the
        images stay with this exam.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} style={{ textTransform: "none" }}>
        Keep MSK worksheet
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={switching}
        onClick={onConfirm}
        style={{ textTransform: "none", fontWeight: 700 }}
      >
        Switch worksheet
      </Button>
    </DialogActions>
  </Dialog>
);
